import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

import Button from '../../../components/Buttons/Button';
import BaseModal from '../../../components/BaseModal';
import Input from '../../../components/Input';
import Slider from '../../../components/Slider';
import doFetch from '../../../api/doFetch';
import Seporator from './Seporator';

const ModalHeaderWrapper = styled.div`
  display: flex;
  color: #283890;
`;

const SubmitAreaStyled = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  margin-top: 32px;
`;

const DealerName = styled.div`
  margin-top: 14px;
  margin-bottom: 6px;
  font-family: NunitoSans;
  font-size: 14px;
  font-weight: bold;
  color: #283890;
`;

export default function ({ isOpen, dealer, toggleHandler, updateDetails }) {
  const [focus, setFocus] = useState(dealer?.commentScriptSettings?.focus || {});
  const [characterLimit, setCharacterLimit] = useState(0);

  useEffect(() => {
    if (dealer?.commentScriptSettings?.focus) setFocus(dealer.commentScriptSettings.focus);
    if (dealer?.commentScriptSettings?.character_limit)
      setCharacterLimit(dealer.commentScriptSettings.character_limit);
  }, [dealer]);

  const handleSubmit = async (event) => {
    event.preventDefault();

    try {
      const commentScriptSettings = {
        enabled: true,
        character_limit: characterLimit,
        regenerate: true,
        focus
      };

      await doFetch(`/dealerships/${dealer.hmsId}/comment-setting`, {
        method: 'PUT',
        body: JSON.stringify({ setting: commentScriptSettings })
      });
      toggleHandler();
      updateDetails({ commentScriptSettings });
    } catch (error) {
      alert(error);
    }
  };

  const handleChange = (key) => (event, newValue) => {
    newValue = newValue * 100;
    const newFocus = Object.fromEntries(Object.entries(focus).map(([k, v]) => [k, v * 100]));
    newFocus[key] = newValue;

    const others = Object.keys(newFocus).filter((k) => k !== key);
    let sumOthers = others.reduce((acc, k) => acc + focus[k], 0);
    let diff = 100 - newValue;

    if (sumOthers === 0) {
      others.forEach((k) => (newFocus[k] = diff / others.length));
    } else {
      others.forEach((k) => (newFocus[k] = Math.round((focus[k] / sumOthers) * diff)));
    }

    setFocus(Object.fromEntries(Object.entries(newFocus).map(([k, v]) => [k, v / 100])));
  };

  return (
    <BaseModal
      isOpen={isOpen}
      toggleHandler={toggleHandler}
      header={<ModalHeaderWrapper>AI GENERATED COMMENTS</ModalHeaderWrapper>}
    >
      <DealerName>{dealer && dealer.name}</DealerName>
      <form onSubmit={handleSubmit}>
        <Input
          type='number'
          min='0'
          step='1'
          value={characterLimit}
          onChange={(e) => setCharacterLimit(e.target.value)}
          label={'Сharacter Limit'}
        />
        <Seporator style={{ marginTop: 24 }} />
        <Slider
          label='Options'
          value={focus?.options}
          min={0}
          max={1}
          step={0.1}
          onChange={handleChange('options')}
        />
        <Slider
          label='Safety'
          value={focus?.safety}
          min={0}
          max={1}
          step={0.1}
          onChange={handleChange('safety')}
        />
        <Slider
          label='Awards'
          value={focus?.awards}
          min={0}
          max={1}
          step={0.1}
          onChange={handleChange('awards')}
        />
        <SubmitAreaStyled>
          <Button type='submit'>Save</Button>
        </SubmitAreaStyled>
      </form>
    </BaseModal>
  );
}
